import { useState } from "react";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";

import CatalogImage from "common/components/CatalogImage";
import LinkButton from "common/components/LinkButton";
import Icon from "common/components/Icon";
import { CrossSellItem } from "common/types/carts";

import { useCrossSellsQuery } from "client/carts/hooks";
import { urls } from "client/routes";
import { useCurrentDrawer } from "client/common/hooks/stackables";
import Loading from "client/common/components/loading/Loading";

import CrossSellsDisclaimerModal from "./CrossSellsDisclaimerModal";

import styles from "../styles/CrossSells.module.less";

type CrossSellLayoutProps = { cartId: number };
type CrossSellProps = { item: CrossSellItem };

const CrossSell = ({ item }: CrossSellProps) => {
  const { close } = useCurrentDrawer();
  const itemUrl = urls.products.detail({
    params: { id: item.product.product_line.id },
    search: {
      item: item.id,
      product: item.product.id,
    },
  });

  return (
    <LinkButton dest={itemUrl} className={styles.main} onClick={close}>
      <CatalogImage className={styles.image} alt={item.name} image={item.image} size="medium" />
      <div className={styles.info}>
        <div className={styles.name}>{item.product.product_line.name}</div>
        <div className={styles.description}>{item.product.product_line.short_description}</div>
      </div>
    </LinkButton>
  );
};

const CrossSells = ({ cartId }: CrossSellLayoutProps) => {
  const { data: crossSells, isLoading, error } = useCrossSellsQuery(cartId);
  const [isDisclaimerModalOpen, setIsDisclaimerModalOpen] = useState(false);

  if (isLoading) {
    return <Loading />;
  }
  if (!crossSells || crossSells.length === 0 || error) {
    return null;
  }
  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>Frequently purchased with...</div>
        <button type="button" onClick={() => setIsDisclaimerModalOpen(true)}>
          <Icon className={styles.icon} icon={faInfoCircle} />
        </button>
      </div>
      <div className={styles.items}>
        {crossSells.map((crossSellItem) => (
          <CrossSell item={crossSellItem} key={crossSellItem.id} />
        ))}
      </div>
      <CrossSellsDisclaimerModal
        visible={isDisclaimerModalOpen}
        onClose={() => setIsDisclaimerModalOpen(false)}
      />
    </div>
  );
};

export default CrossSells;
